import { render, staticRenderFns } from "./AlertHistory.vue?vue&type=template&id=101e9236"
import script from "./AlertHistory.vue?vue&type=script&lang=js"
export * from "./AlertHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eb30a0289a409b0a489ae932e3a15a73/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports